<template>
  <div class="animated fadeIn">
    <router-view></router-view>
  </div>
</template>
<script>
    export default {

    }
</script>
